import { render, staticRenderFns } from "./index.vue?vue&type=template&id=36fbc578&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=36fbc578&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36fbc578",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/data/.jenkins/workspace/yyWebsite/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36fbc578')) {
      api.createRecord('36fbc578', component.options)
    } else {
      api.reload('36fbc578', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=36fbc578&scoped=true&", function () {
      api.rerender('36fbc578', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cliniNutrit/index.vue"
export default component.exports